#import "../fragments/team-fragment.graphql"

query GetTeams {
    teams {
        ...TeamFragment
    }
}
